import * as yup from 'yup'

const lineItemSchema = yup.object().shape({
  type: yup.string().required('Type is required'),
  description: yup.string().required('Description is required'),
  quantity: yup.number().typeError('Please enter a valid quantity').required('Quantity is required').min(0, 'Quantity must be positive'),
  unit: yup.string(),
  price: yup.number().typeError('Please enter a valid price').required('Price is required').min(0, 'Price must be positive'),
  tax: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .min(0, 'Tax must be positive')
    .max(100, 'Tax must be at most 100%')
})

const billSchema = yup.object().shape({
  type: yup.string().required('Type is required'),
  percentDue: yup
    .number()
    .typeError('Please enter a valid percent due')
    .required('Percent Due is required')
    .min(0, 'Percent Due must be positive')
    .max(100, 'Percent Due must be at most 100%'),
  lineItems: yup.array().of(lineItemSchema).min(1, 'At least one line item is required').required('At least one line item is required')
})

export { billSchema }
